type NavigationLinkImage = {
  title: string
  url: string
  linkTo: string
}

type LinkObject = {
  title: string
  url: string
}

export type NavigationLinksObject = {
  title: string
  links: ReadonlyArray<LinkObject>
}

export type NavigationLinksCategories = {
  title: string
  url: string
  highlighted?: boolean
  feature: ReadonlyArray<NavigationLinkImage>
  links: ReadonlyArray<NavigationLinksObject>
}

export const NavigationLinks: ReadonlyArray<NavigationLinksCategories> = [
  {
    title: 'New Arrivals',
    url: '/new-arrivals',
    feature: [
      {
        title: 'Curated Collections',
        url:
          'https://saatchi-general.s3.us-east-1.amazonaws.com/navigation/Curated+Collections.jpg',
        linkTo: '/collections',
      },
      {
        title: 'Curated Deals',
        url: 'https://saatchi-general.s3.us-east-1.amazonaws.com/navigation/curated_deals.jpg',
        linkTo: '/curated-deals',
      },
    ],
    links: [
      {
        title: '',
        links: [
          { title: 'Recently Added', url: '/new-arrivals' },
          { title: 'New Art Under $500', url: '/new-arrivals?geo_prices=0-500' },
          { title: 'New Art Under $1,000', url: '/new-arrivals?geo_prices=0-1000' },
          { title: "Chief Curator's Picks", url: '/collections/new-arrivals' },
        ],
      },
    ],
  },
  {
    title: 'Paintings',
    url: '/paintings',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-paintings-v4.jpg',
        title: 'Featured Paintings',
        linkTo:
          'https://www.saatchiart.com/art-collection/painting/Featured-Paintings/1586325/856183/view',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/paintings-abstracts.jpg',
        title: 'Best of Abstracts',
        linkTo: 'https://www.saatchiart.com/art-collection/Best-of-Abstracts/2131451/861229/view',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/paintings-landscapes.jpg',
        title: 'Best of Landscapes',
        linkTo: 'https://www.saatchiart.com/art-collection/Best-of-Landscapes/1861756/861111/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Figurative',
            url: '/paintings/figurative',
          },
          {
            title: 'Abstract',
            url: '/paintings/abstract',
          },
          {
            title: 'Contemporary',
            url: '/paintings/contemporary',
          },
          {
            title: 'Street Art',
            url: '/paintings/street-art',
          },
          {
            title: 'Pop Art',
            url: '/paintings/pop-art',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'People',
            url: '/paintings/people',
          },
          {
            title: 'Landscape',
            url: '/paintings/landscape',
          },
          {
            title: 'Still Life',
            url: '/paintings/still-life',
          },
          {
            title: 'Nature',
            url: '/paintings/nature',
          },
          {
            title: 'Beach',
            url: '/paintings/beach',
          },
        ],
      },
      {
        title: 'Medium',
        links: [
          {
            title: 'Oil',
            url: '/paintings/oil',
          },
          {
            title: 'Watercolor',
            url: '/paintings/watercolor',
          },
          {
            title: 'Acrylic',
            url: '/paintings/acrylic',
          },
          {
            title: 'Airbrush',
            url: '/paintings/airbrush',
          },
          {
            title: 'Ink',
            url: '/paintings/ink',
          },
        ],
      },
    ],
  },
  {
    title: 'Photography',
    url: '/photography',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-photography-v4.jpg',
        title: 'Featured Photography',
        linkTo:
          'https://www.saatchiart.com/art-collection/Featured-Photography/2131451/856313/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Surrealism',
            url: '/photography/surrealism',
          },
          {
            title: 'Portraiture',
            url: '/photography/portraiture',
          },
          {
            title: 'Abstract',
            url: '/photography/abstract',
          },
          {
            title: 'Documentary',
            url: '/photography/documentary',
          },
          {
            title: 'Conceptual',
            url: '/photography/conceptual',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Landscape',
            url: '/photography/landscape',
          },
          {
            title: 'People',
            url: '/photography/people',
          },
          {
            title: 'Nature',
            url: '/photography/nature',
          },
          {
            title: 'Still Life',
            url: '/photography/still-life',
          },
          {
            title: 'Nude',
            url: '/photography/nude',
          },
        ],
      },
      {
        title: 'Medium',
        links: [
          {
            title: 'Digital',
            url: '/photography?mediums=digital',
          },
          {
            title: 'Black and White',
            url: '/photography/black-white',
          },
          {
            title: 'Color',
            url: '/photography/color',
          },
          {
            title: 'C-type',
            url: '/photography/c-type',
          },
          {
            title: 'Giclée',
            url: '/photography/gicl-e',
          },
        ],
      },
    ],
  },
  {
    title: 'Sculpture',
    url: '/sculpture',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-sculpture-v4.jpg',
        title: 'Featured Sculptures',
        linkTo:
          'https://www.saatchiart.com/art-collection/sculpture-painting/Featured-Sculptures/1861756/726057/view',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/sculpt-outdoorsculpt.jpg',
        title: 'Best of Outdoor Sculpture',
        linkTo:
          'https://www.saatchiart.com/art-collection/Best-of-Outdoor-Sculptures/1586325/860321/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Pop Art',
            url: '/sculpture/pop-art',
          },
          {
            title: 'Abstract',
            url: '/sculpture/abstract',
          },
          {
            title: 'Minimalism',
            url: '/sculpture/minimalism',
          },
          {
            title: 'Figurative',
            url: '/sculpture/figurative',
          },
          {
            title: 'Modernism',
            url: '/sculpture/modernism',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Body',
            url: '/sculpture/body',
          },
          {
            title: 'Still Life',
            url: '/sculpture/still-life',
          },
          {
            title: 'Animal',
            url: '/sculpture/animal',
          },
          {
            title: 'Architecture',
            url: '/sculpture/architecture',
          },
          {
            title: 'Geometric',
            url: '/sculpture/geometric',
          },
        ],
      },
      {
        title: 'Method',
        links: [
          {
            title: '3D Sculpting',
            url: '/sculpture/3d-sculpting',
          },
          {
            title: 'Assemblage',
            url: '/sculpture/assemblage',
          },
          {
            title: 'Modeling',
            url: '/sculpture/modeling',
          },
          {
            title: 'Carving',
            url: '/sculpture/carving',
          },
          {
            title: 'Casting',
            url: '/sculpture/casting',
          },
        ],
      },
    ],
  },
  {
    title: 'Drawings',
    url: '/drawings',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-drawing-v4.jpg',
        title: 'Featured Drawings',
        linkTo: 'https://www.saatchiart.com/art-collection/Featured-Drawings/1754780/854095/view',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Graffiti',
            url: '/drawings/graffiti',
          },
          {
            title: 'Abstract',
            url: '/drawings/abstract',
          },
          {
            title: 'Figurative',
            url: '/drawings/figurative',
          },
          {
            title: 'Pop Art',
            url: '/drawings/pop-art',
          },
          {
            title: 'Surrealism Art',
            url: '/drawings/surrealism',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Nature',
            url: '/drawings/nature',
          },
          {
            title: 'People',
            url: '/drawings/people',
          },
          {
            title: 'Animal',
            url: '/drawings/animal',
          },
          {
            title: 'Love',
            url: '/drawings/love',
          },
          {
            title: 'Cartoon',
            url: '/drawings/cartoon',
          },
        ],
      },
      {
        title: 'Medium',
        links: [
          {
            title: 'Pencil',
            url: '/drawings/pencil',
          },
          {
            title: 'Charcoal',
            url: '/drawings/charcoal',
          },
          {
            title: 'Digital',
            url: '/drawings?mediums=digital',
          },
          {
            title: 'Ink',
            url: '/drawings/ink',
          },
          {
            title: 'Pastel',
            url: '/drawings/pastel',
          },
        ],
      },
    ],
  },
  {
    title: 'Prints',
    url: '/prints',
    feature: [
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-prints-v4.jpg',
        title: 'Fine Art Prints',
        linkTo: 'https://www.saatchiart.com/stories/fine-art-prints',
      },
      {
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-art-prints-v4.jpg',
        title: 'Featured Art Prints',
        linkTo: 'https://www.saatchiart.com/art-collection/Featured-Prints/1754780/857921/view ',
      },
    ],
    links: [
      {
        title: 'Style',
        links: [
          {
            title: 'Expressionism',
            url: '/prints/expressionism',
          },
          {
            title: 'Abstract',
            url: '/prints/abstract',
          },
          {
            title: 'Art Deco',
            url: '/prints/art-deco',
          },
          {
            title: 'Pop Art',
            url: '/prints/pop-art',
          },
          {
            title: 'Folk Art',
            url: '/prints/folk',
          },
        ],
      },
      {
        title: 'Subject',
        links: [
          {
            title: 'Floral',
            url: '/prints/floral',
          },
          {
            title: 'Animal',
            url: '/prints/animal',
          },
          {
            title: 'Fashion',
            url: '/prints/fashion',
          },
          {
            title: 'Beach',
            url: '/prints/beach',
          },
          {
            title: 'Geometric',
            url: '/prints/geometric',
          },
        ],
      },
      {
        title: 'Material',
        links: [
          {
            title: 'Fine Art Paper',
            url: '/prints?prints_materials=rag',
          },
          {
            title: 'Photo Paper',
            url: '/prints?prints_materials=photo',
          },
          {
            title: 'Canvas',
            url: '/prints?prints_materials=canvas',
          },
          {
            title: 'Metal',
            url: '/prints?prints_materials=metal',
          },
          {
            title: 'Acrylic',
            url: '/prints?prints_materials=acrylic',
          },
        ],
      },
    ],
  },
  {
    title: 'Inspiration',
    url: '/stories',
    feature: [
      {
        title: 'Collector Stories',
        url: 'https://images.saatchiart.com/saatchi-general/homepage/collector-stories-resized.jpg',
        linkTo: 'https://www.saatchiart.com/livingwithart',
      },
      {
        title: 'Why Buy Original Art',
        url:
          'https://saatchi-general.s3.us-east-1.amazonaws.com/homepage/4-reasons-to-buy-original-art-resized.jpg',
        linkTo: 'https://www.saatchiart.com/pages/why-buy-original-art',
      },
      {
        title: 'Anniversary Collections',
        url:
          'https://www.saatchiart.com/saatchi-general//navigation/dropdown/v2/navigation-anniversary-picks-2026.jpg',
        linkTo: '/stories/16yearsofart',
      },
    ],
    links: [
      {
        title: '',
        links: [
          {
            title: 'Curated Collections',
            url: '/collections',
          },
          {
            title: 'Digital Exhibitions',
            url: '/shows',
          },
          {
            title: 'Catalog',
            url: '/catalog',
          },
          {
            title: 'Art Stories',
            url: '/stories',
          },
          {
            title: 'Trending Artists',
            url: '/trendingartists',
          },
          {
            title: 'Living With Art',
            url: '/livingwithart',
          },
        ],
      },
      {
        title: '',
        links: [
          {
            title: 'Rising Stars',
            url: '/risingstars',
          },
          {
            title: 'The Other Art Fair',
            url: '/theotherartfair',
          },
          {
            title: 'Art Style Quiz',
            url: '/quiz/art-for-your-style-quiz ',
          },
          {
            title: 'Blog',
            url: '//canvas.saatchiart.com/',
          },
          {
            title: 'Shop by Room',
            url: '/pages/art-for-every-room',
          },
          {
            title: 'Make an Offer',
            url: '/pages/make-an-offer-on-art-you-love',
          },
        ],
      },
    ],
  },
  {
    title: 'Art Advisory',
    url: '/artadvisory',
    feature: [
      {
        title: 'How to Shop for Your Home',
        url:
          'https://saatchi-general.s3.us-east-1.amazonaws.com/homepage/how-to-buy-art-for-your-home-resized.jpg',
        linkTo: '/pages/how-to-buy-art-for-your-home',
      },
    ],
    links: [
      {
        title: '',
        links: [
          { title: 'About Art Advisory', url: '/artadvisory' },
          { title: 'Meet The Experts', url: '/artadvisory#team' },
          { title: 'Commission An Artwork', url: '/commissions' },
          { title: 'Contact Art Advisors', url: '/artadvisory/brief' },
        ],
      },
    ],
  },
  {
    title: 'Trade',
    url: '/trade',
    feature: [
      {
        title: 'Trade Program',
        url:
          'https://images.saatchiart.com/saatchi-general/navigation/dropdown/v2/saatchi-featured-trade-v4.jpg',
        linkTo: '/trade/trade-program',
      },
    ],
    links: [
      {
        title: '',
        links: [
          {
            title: 'Saatchi Art For Business ',
            url: '/trade',
          },
          {
            title: 'Trade Program',
            url: '/trade/trade-program',
          },
          {
            title: 'Hospitality',
            url: '/trade/hospitality',
          },
          {
            title: 'Contact Art Consultants',
            url: '/trade-hospitality#contact',
          },
        ],
      },
    ],
  },
  {
    title: 'Curated Deals',
    url: '/curated-deals',
    feature: [
      {
        title: '',
        url: '',
        linkTo: '',
      },
    ],
    links: [],
  },
  {
    title: 'Anniversary Picks',
    highlighted: true,
    url: '/stories/16yearsofart',
    feature: [
      {
        title: '',
        url: '',
        linkTo: '',
      },
    ],
    links: [],
  },
]
